<div class="card mt-3">
    <div class="card-header">
        <div class="col-12 d-flex row">
            <div style="flex-direction: row; display: flex; position: relative; width: 90%;">
                Chamados&nbsp;&nbsp;&nbsp;&nbsp;
                <div class="form-check form-switch" style="margin-left: 5px;" *ngIf="ciclo">
                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                        (change)="alternarChamadosCiclo()" checked>
                    <label class="form-check-label" for="flexSwitchCheckDefault"><span>Chamados Ciclo</span></label>
                </div>
            </div>
            <div class="div-btn-goback">
                <a class="btn btn-success btn-sm btn-goback" id="tooltip" routerLink="/chamados/abertura"
                    title="Abrir Chamado"><i class="fa fa-plus"></i>&nbsp;&nbsp;Cadastrar</a>
            </div>
        </div>
    </div>
    <div class="card-body">
        <form [formGroup]="form">
            <div class="row">
                <div class="col-12 col-md-3" *ngIf="master">
                    <app-select-field-search [itens]="listaGestores" type="text" label="Gestor" formControlName="gestor">
                    </app-select-field-search>
                </div>
                <div class="col-12 col-md-2" *ngIf="!cicloAtivo">
                    <app-select-field-search type="text" label="Status" formControlName="status" [itens]="listaStatus">
                    </app-select-field-search>
                </div>
                <div class="col-12 col-md-3">
                    <app-input-field type="text" label="Protocolo" formControlName="protocolo">
                    </app-input-field>
                </div>
                <div class="col-12 col-md-2">
                    <app-select-field-search [itens]="listaCategorias" type="text" label="Categoria" formControlName="categoria">
                    </app-select-field-search>
                </div>
                <div class="col-12 col-md-2 text-center mb-3 mb-md-0">
                    <label class="form-label d-nome d-md-block">&nbsp;</label>
                    <a class="btn btn-primary" title="Buscar" (click)="loadItens()" data-toggle="tooltip" data-placement="top" title="Buscar Oficina">Buscar
                        <i class="fa fa-search"></i></a>
                </div>
            </div>
        </form>
        <div *ngIf="listaChamados && listaChamados.length == 0" class="alert alert-warning" role="alert">
            Nenhum registro localizado!
        </div>

        <table class="table">
            <thead>
                <tr class="table-info">
                    <th scope="col">Protocolo</th>
                    <th scope="col">Assunto</th>
                    <th scope="col" *ngIf="master">Gestor</th>
                    <th scope="col" *ngIf="master">Prioridade</th>
                    <th scope="col">Status</th>
                    <th scope="col">Categoria</th>
                    <th scope="col" *ngIf="master">Empresa</th>
                    <th scope="col" *ngIf="master">Tipo Empresa</th>
                    <th scope="col" class="text-center">Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let item of listaChamados | paginate: { itemsPerPage: limit, totalItems: totalRegistros, currentPage: page }; let i = index; "
                    [class]="retornaClasseDePrioridade(item.prioridade)" class="tr-table">
                    <td scope="row">{{item.protocolo}}</td>
                    <td>{{item.assunto}}</td>
                    <td *ngIf="master">{{item.nome_gestor}}</td>
                    <td *ngIf="master">{{retornaPrioridade(item.prioridade)}}</td>
                    <td>{{item.status}}</td>
                    <td>{{obterCategoria(item.categoria)}}</td>
                    <td *ngIf="master" [title]="item.razao_social" class="help">{{item.fantasia}}</td>
                    <td *ngIf="master">{{item.tipo == 'CORPORATE'?'Associação':item.tipo}}</td>
                    <td class="text-center">
                        <div class="col-12 d-flex row justify-content-center">
                            <div class="btn-action">
                                <button class="btn btn-primary" title="Abrir Chamado" (click)="abrirChamado(item.protocolo, item)">
                                    <i class="fa fa-folder"></i>
                                </button>
                                <button class="btn btn-danger" title="Desativar Notificação" (click)="removerNotificacao(item.protocolo)"
                                    *ngIf="notificacaoAtiva(item.protocolo)">
                                    <i class="fa fa-times"></i>
                                </button>
                                <button class="btn btn-success" title="Ativar Notificação" (click)="adicionarNotificacao(item.protocolo)"
                                    *ngIf="!notificacaoAtiva(item.protocolo)">
                                    <i class="fa fa-check"></i>
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="col-12 text-center mt-2">
            <pagination-controls
                (pageChange)="pageChange($event)"
                previousLabel="Anterior"
                nextLabel="Próximo">
            </pagination-controls>
        </div>
    </div>
</div>